/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Creation_TextInputs */

const en_a11y_statement_creation_text = /** @type {(inputs: A11y_Statement_Creation_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This statement was created on March 24, 2026.`)
};

const de_a11y_statement_creation_text = /** @type {(inputs: A11y_Statement_Creation_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Erklärung wurde am 24. März 2026 erstellt.`)
};

const fr_a11y_statement_creation_text = /** @type {(inputs: A11y_Statement_Creation_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette declaration a ete creee le 24 mars 2026.`)
};

const es_a11y_statement_creation_text = /** @type {(inputs: A11y_Statement_Creation_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta declaracion fue creada el 24 de marzo de 2026.`)
};

const it_a11y_statement_creation_text = /** @type {(inputs: A11y_Statement_Creation_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa dichiarazione e stata creata il 24 marzo 2026.`)
};

const nl_a11y_statement_creation_text = /** @type {(inputs: A11y_Statement_Creation_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze verklaring is opgesteld op 24 maart 2026.`)
};

const pl_a11y_statement_creation_text = /** @type {(inputs: A11y_Statement_Creation_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niniejsze oswiadczenie zostalo sporzadzone 24 marca 2026 r.`)
};

const fi_a11y_statement_creation_text = /** @type {(inputs: A11y_Statement_Creation_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä lausunto on laadittu 24. maaliskuuta 2026.`)
};

const da_a11y_statement_creation_text = /** @type {(inputs: A11y_Statement_Creation_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne erklaering blev oprettet den 24. marts 2026.`)
};

const sv_a11y_statement_creation_text = /** @type {(inputs: A11y_Statement_Creation_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denna forklaring skapades den 24 mars 2026.`)
};

/**
* | output |
* | --- |
* | "This statement was created on March 24, 2026." |
*
* @param {A11y_Statement_Creation_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_creation_text = /** @type {((inputs?: A11y_Statement_Creation_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Creation_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_creation_text(inputs)
	if (locale === "fr") return fr_a11y_statement_creation_text(inputs)
	if (locale === "es") return es_a11y_statement_creation_text(inputs)
	if (locale === "it") return it_a11y_statement_creation_text(inputs)
	if (locale === "nl") return nl_a11y_statement_creation_text(inputs)
	if (locale === "pl") return pl_a11y_statement_creation_text(inputs)
	if (locale === "fi") return fi_a11y_statement_creation_text(inputs)
	if (locale === "da") return da_a11y_statement_creation_text(inputs)
	if (locale === "sv") return sv_a11y_statement_creation_text(inputs)
	return en_a11y_statement_creation_text(inputs)
});